module.exports = __webpack_public_path__ + "static/img/5.f78c51e1.png";